export default __webpack_public_path__ + "static/media/480_dummy2016-irishpub01-de.47318539.png";